import { render, staticRenderFns } from "./AvalaraTaxCode.vue?vue&type=template&id=16a14080&"
import script from "./AvalaraTaxCode.vue?vue&type=script&lang=ts&"
export * from "./AvalaraTaxCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports